import 'bpk-stylesheets';
import 'react-app-polyfill/ie11'; // For IE 11 support
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

ReactDOM.render(React.createElement(App), document.getElementById('root'));
